<template>
    <form id="form" class="message-widget">

        <div class="message-widget__title-wrap">
            <span class="icon-message message-widget__title-icon"></span>
            <h2 class="message-widget__title">{{locales && locales.property && locales.property.message}}</h2>
        </div>

        <theme-textarea
            label=""
            name="message"
            :placeholder="locales && locales.property && locales.property.message_placeholder"
            v-model="body"
            :gray="true"
            v-validate="`required`"
        ></theme-textarea>

        <a v-if="isGuest" :class="['theme-btn theme-btn--white', {'theme-btn--white-disabled': !body}]" data-feature="open-modal" data-target="login">
            {{ buttonName }}
        </a>
        <button v-else :class="['theme-btn theme-btn--white', {'theme-btn--white-disabled': !body}]"
            :disabled="isDisabled"
            @click.prevent="send">{{ buttonName }}
        </button>

    </form>
</template>

<script>
import sweetalert from "sweetalert";
import { mapGetters, mapActions } from "vuex";
import _ from "lodash";
import $ from "jquery";
import ThemeTextarea from './ThemeTextarea.vue';

export default {
    components: {
        ThemeTextarea,
    },
    $_veeValidate: {
    validator: "new",
  },
    computed: {
        ...mapGetters(["locales"])
    },
    data() {
        return {
            body: null,
            isDisabled: false
        }
    },
    props: {
        propertyId: {
            default: '',
            type: String,
        },
        buttonName: {
            default: '',
            type: String,
        },
        isGuest: {
            default: '',
            type: String,
        },
    },
    methods: {
        send: function () {
            let that = this;
            this.$validator.validateAll().then((res) => {
                if (res && !that.isDisabled) {
                    that.isDisabled = true;
                    window.axios.post('/api/messages', {
                        body: this.body,
                        property_id: this.propertyId
                    }).then((response) => {
                        this.body = null;
                        that.isDisabled = false;
                        this.$validator.reset();
                        let page = document.getElementById('page');
                        page.classList.remove("z-index");
                        sweetalert(this.locales.common.success, this.locales.property.message_sent, 'success');
                    }, (response) => {
                        sweetalert(this.locales.common.error, this.locales.common.login_required, 'error').then(()=>{ window.location.reload() });
                    })
                }
            })
        }
    },
}
</script>


// WEBPACK FOOTER //
// resources/js/components/MessageWidget.vue